import { ReactNode } from 'react';
import { JoinAnOrgBanner } from 'components/home_bar';
import { AppBar } from 'features/app_shell/app_bar';
import { AppShell } from 'features/app_shell/AppShell';
import { CenterPanel } from 'features/app_shell/CenterPanel';
import { SidePanel } from 'features/app_shell/SidePanel';
import { LeftNavigation, LeftNavigationContext } from 'features/left_navigation';
import { OrgConsolidationGlobalNotification } from 'features/organization_consolidation';
const mainNavContainerCss = "mchm70r";
const appBarContainerCss = "azilaw5";
const bodyRowCss = "bqpt1d6";

/** Shared card shape for content and side panel — border-radius zeroed on mobile in one place. */
const bodyPanelCss = "blz4dlx";
interface AppLayoutProps {
  children: ReactNode;
}

/**
 * Top-level layout orchestrator for the product refresh app shell.
 * Composes the left nav, app bar, center panel, and optional side panel into a full-viewport grid.
 *
 * @param children - Page content rendered inside `CenterPanel`.
 */
export const AppLayout = ({
  children
}: AppLayoutProps) => <LeftNavigationContext>
    <AppShell>
      <div className={mainNavContainerCss} id="shell-main-nav">
        <LeftNavigation />
      </div>
      <div className={appBarContainerCss} id="shell-app-bar">
        <AppBar />
      </div>
      <div className={bodyRowCss} id="shell-body">
        <CenterPanel className={bodyPanelCss}>
          <OrgConsolidationGlobalNotification />
          <JoinAnOrgBanner />
          {children}
        </CenterPanel>
        <SidePanel className={bodyPanelCss} />
      </div>
    </AppShell>
  </LeftNavigationContext>;

require("./AppLayout.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AppLayout.tsx");